<script>
	export let visible = true;
	export let secondary = true;
	
	function hideModal() {
		visible = false;
	}
	
	function escapeModal(event) {
		if (event.key === "Escape" && visible) {
			visible = false;
		}
	}
</script>

<svelte:window on:keydown={escapeModal} />

<div class="overlay" role="dialog" class:visible={visible} on:click|self={hideModal}>
	<div class="modal">
		<slot name="content">
			<div class="content">
				<h3>
					This is a modal.
				</h3>
				<p>
					This is a modal window, also known as a dialog box. A modal is an interface element that appears over other content. It requires an interaction from the user before they can return to whatever is underneath.
				</p>
			</div>
		</slot>
		
		<div class="actions">
			{#if secondary}
				<button id="close" class="secondary" on:click={hideModal}>
					<span>Close</span>
				</button>
				<slot name="primary-action">
					<button id="okay" on:click={hideModal}>
						<span>Okay</span>
					</button>
				</slot>
			{:else}
				<button id="close" class="full-width" on:click={hideModal}>
					<span>Close</span>
				</button>
			{/if}
		</div>
		
	</div>
</div>

<style>
	
</style>